import React, { useState, useEffect, useCallback } from "react";
import {
  getCurrencyRates,
  convertToBaseCurrency,
  convertToCurrency,
  formatData,
} from "../../../services/BackendServices";

const OfferDetails = ({
  offer,
  btnShortlist = false,
  btnRemoveShortlist = false,
  btnSendQuery = false,
  btnRequestQuote = false,
  btnRequestSpecifications = false,
  btnRequestBestPrice = false,
  btnNegotiate = false,
  btnRequestShippingDetails = false,
  btnLogisticsSupport = false,
  btnRaiseQuery = false,
}) => {
  const [activeTab, setActiveTab] = useState("otherInfo");

  // Effect hooks
  useEffect(() => {
    getCurrencyRates();
  }, []);
  // Format date to DD/MM/YYYY format
  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    } catch (error) {
      return dateString;
    }
  };

  // Handle tab click for offer details
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // Calculate per MT prices
  const calculatePerMTPrice = (totalPrice, quantity) => {
    if (!totalPrice || !quantity || quantity === 0) return "";
    const perMTPrice = parseFloat(totalPrice) / parseFloat(quantity);
    return isNaN(perMTPrice) ? "" : perMTPrice;
  };

  return (
    <>
      <section className="product-details2">
        <div className="tabs">
          <button
            className={activeTab === "otherInfo" ? "active" : ""}
            onClick={() => handleTabClick("otherInfo")}
          >
            Offer Information
          </button>
          <button
            className={activeTab === "specifications" ? "active" : ""}
            onClick={() => handleTabClick("specifications")}
          >
            Commodity Details
          </button>
          <button
            className={activeTab === "qtypkg" ? "active" : ""}
            onClick={() => handleTabClick("qtypkg")}
          >
            Quantity & Packaging
          </button>
          <button
            className={activeTab === "shipping" ? "active" : ""}
            onClick={() => handleTabClick("shipping")}
          >
            Delivery & Logistic
          </button>
          <button
            className={activeTab === "pricing" ? "active" : ""}
            onClick={() => handleTabClick("pricing")}
          >
            Pricing/Payment/Guarantee
          </button>
          <button
            className={activeTab === "priceBreakup" ? "active" : ""}
            onClick={() => handleTabClick("priceBreakup")}
          >
            Price Breakup
          </button>
          <button
            className={activeTab === "others" ? "active" : ""}
            onClick={() => handleTabClick("others")}
          >
            Others
          </button>
          <button
            className={activeTab === "remarks" ? "active" : ""}
            onClick={() => handleTabClick("remarks")}
          >
            Remarks
          </button>
        </div>

        {activeTab === "otherInfo" && (
          <div className="tab-content active">
            <div className="row">
              <div className="col-lg-12 col-sm-9 col-6">
                <div className="row">
                  <div className="col-lg-3 col-sm-4 col-6">
                    <label>Offer No.</label>
                    <input
                      type="text"
                      readOnly
                      value={offer.OfferNumber || ""}
                      className="form-control"
                    />
                  </div>
                  <div className="col-lg-3 col-sm-4 col-6">
                    <label>Offer Type</label>
                    <input
                      type="text"
                      readOnly
                      value={offer.OfferType || ""}
                      className="form-control"
                    />
                  </div>
                  <div className="col-lg-3 col-sm-4 col-6">
                    <label htmlFor="offerStatus">Offer Status</label>
                    <input
                      id="offerStatus"
                      type="text"
                      value={offer?.OfferStatus || "Indicative"}
                      className="form-control"
                      readOnly
                    />
                  </div>
                  <div className="col-lg-3 col-sm-4 col-6">
                    <label>Creation Date</label>
                    <input
                      type="text"
                      readOnly
                      value={formatDate(offer.CreatedAt || "")}
                      className="form-control"
                    />
                  </div>
                  <div className="col-lg-3 col-sm-4 col-6">
                    <label>Expiry Date</label>
                    <input
                      type="text"
                      readOnly
                      value={formatDate(offer.Expires || "")}
                      className="form-control"
                    />
                  </div>
                  <div className="col-lg-6 col-sm-8 col-12">
                    <label htmlFor="sellerInformation">
                      Seller Information
                    </label>
                    <input
                      id="sellerInformation"
                      type="text"
                      value={offer?.Sellerinformation || "AMTPL"}
                      className="form-control"
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-3 col-6">
                <div className="actions">
                  <div className="row">
                    <div className="col-12 mb-2">
                      {btnRemoveShortlist && (
                        <button className="submit-btn-more">Remove</button>
                      )}
                    </div>
                    <div className="col-12 mb-2">
                      {btnSendQuery && (
                        <button className="submit-btn-more">Send Query</button>
                      )}
                    </div>
                    <div className="col-12 mb-2">
                      {btnSendQuery && (
                        <button className="submit-btn-more">Send Query</button>
                      )}
                    </div>
                    <div className="col-12 mb-2">
                      {btnRequestQuote && (
                        <button className="submit-btn-more">
                          Request Quote
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === "specifications" && (
          <div className="tab-content active">
            <div className="row">
              <div className="col-lg-3 col-sm-4 col-6">
                <label>Category</label>
                <input
                  type="text"
                  readOnly
                  value={offer.CategoryName || ""}
                  className="form-control"
                />
              </div>
              <div className="col-lg-3 col-sm-4 col-6">
                <label>Product</label>
                <input
                  type="text"
                  readOnly
                  value={offer.ProductName || ""}
                  className="form-control"
                />
              </div>
              <div className="col-lg-3 col-sm-4 col-6">
                <label htmlFor="hsCode">HS Code</label>
                <input
                  id="hsCode"
                  type="text"
                  value={offer?.HsCode || ""}
                  className="form-control"
                  readOnly
                  placeholder=""
                />
              </div>
              <div className="col-lg-3 col-sm-4 col-6">
                <label>Grade</label>
                <input
                  type="text"
                  readOnly
                  value={offer.Grade || ""}
                  className="form-control"
                />
              </div>
              <div className="col-lg-3 col-sm-4 col-6">
                <label htmlFor="variety">Variety</label>
                <input
                  id="variety"
                  type="text"
                  value={offer?.Variety || ""}
                  className="form-control"
                  readOnly
                  placeholder=""
                />
              </div>
              <div className="col-lg-3 col-sm-4 col-6">
                <label>Origin Country</label>
                <input
                  type="text"
                  readOnly
                  value={offer.Country || ""}
                  className="form-control"
                />
              </div>
              <div className="col-lg-6 col-sm-6 col-6">
                <div className="row">
                  {offer.productSpecifications && (
                    <div className="col-12">
                      <label htmlFor="productSpecifications">
                        Product Specifications
                      </label>
                      <textarea
                        id="productSpecifications"
                        name="productSpecifications"
                        className="form-control"
                        rows="5"
                        value={offer.productSpecifications || ""}
                        readOnly
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-3 col-sm-3 col-6">
                <div className="actions">
                  <div className="row">
                    <div className="col-12 mb-2">
                      {btnRequestSpecifications && (
                        <button className="submit-btn-more">
                          Request Specifications
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === "qtypkg" && (
          <div className="tab-content active">
            <div className="row">
              <div className="col-lg-9 col-sm-9 col-6">
                <div className="row">
                  <div className="col-lg-3 col-sm-4 col-6">
                    <label>Offered Quantity (MT)</label>
                    <input
                      type="text"
                      readOnly
                      value={offer.Quantity || ""}
                      className="form-control"
                    />
                  </div>
                  <div className="col-lg-3 col-sm-4 col-6">
                    <label htmlFor="packagingType">Packaging Type</label>
                    <select
                      id="packagingType"
                      className="form-control"
                      value={offer?.PackagingType || "Bulk"}
                      readOnly
                    >
                      <option value="Bulk">Bulk</option>
                      <option value="Bags">Bags</option>
                    </select>
                  </div>
                  <div className="col-lg-3 col-sm-4 col-6">
                    <label htmlFor="packagingSize">Packaging Size</label>
                    <input
                      id="packagingSize"
                      type="text"
                      value={offer?.PackagingSize || "50kg"}
                      className="form-control"
                      readOnly
                      placeholder="e.g., 50kg"
                    />
                  </div>
                  <div className="col-lg-9 col-sm-8 col-12">
                    <label htmlFor="additionalPackagingNotes">
                      Additional Packaging Notes
                    </label>
                    <textarea
                      id="additionalPackagingNotes"
                      value={offer?.AdditionalPackagingNotes || ""}
                      className="form-control"
                      readOnly
                      rows="3"
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-3 col-6">
                <div className="actions">
                  <div className="row">
                    <div className="col-12 mb-2"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === "shipping" && (
          <div className="tab-content active">
            <div className="row">
              <div className="col-lg-9 col-sm-9 col-6">
                <div className="row">
                  <div className="col-lg-3 col-sm-4 col-6">
                    <label htmlFor="shippingMethodPreference">
                      Shipping Method Preference
                    </label>
                    <input
                      id="shippingMethodPreference "
                      type="text"
                      value={offer?.ShippingMethodPreference || "Ocean"}
                      className="form-control"
                      readOnly
                    />
                  </div>
                  <div className="col-lg-3 col-sm-4 col-6">
                    <label htmlFor="loadingPort">Loading Port</label>
                    <input
                      id="State "
                      type="text"
                      value={offer?.State || ""}
                      className="form-control"
                      readOnly
                    />
                  </div>
                  <div className="col-lg-3 col-sm-4 col-6">
                    <label htmlFor="deliveryPort">Delivery Port</label>
                    <input
                      id="deliveryPort"
                      type="text"
                      value={offer?.DischargePort || ""}
                      className="form-control"
                      readOnly
                    />
                  </div>
                  <div className="col-lg-3 col-sm-4 col-6">
                    <label htmlFor="loadingLocation">Loading Location</label>
                    <input
                      id="loadingLocation "
                      type="text"
                      value={offer?.State || ""}
                      className="form-control"
                      readOnly
                    />
                  </div>
                  <div className="col-lg-3 col-sm-4 col-6">
                    <label htmlFor="deliveryLocation">Delivery Location</label>
                    <input
                      id="deliveryLocation"
                      type="text"
                      value={offer?.DestinationCountry || ""}
                      className="form-control"
                      readOnly
                      placeholder=""
                    />
                  </div>
                  <div className="col-lg-3 col-sm-4 col-6">
                    <label htmlFor="incoterms">Incoterms</label>
                    <input
                      id="incoterms"
                      type="text"
                      value={offer?.INCO || ""}
                      className="form-control"
                      readOnly
                      placeholder=""
                    />
                  </div>
                  <div className="col-lg-3 col-sm-4 col-6">
                    <label htmlFor="transitTime">Transit Time</label>
                    <input
                      id="transitTime"
                      type="text"
                      value={offer?.TransitTime || "60 Days Approx"}
                      className="form-control"
                      readOnly
                    />
                  </div>
                  <div className="col-lg-3 col-sm-4 col-6">
                    <label htmlFor="partialDeliveryAllowed">
                      Partial Delivery Allowed?
                    </label>
                    <input
                      id="partialDeliveryAllowed"
                      type="text"
                      value={offer?.PartialDeliveryAllowed || "No"}
                      className="form-control"
                      readOnly
                      placeholder=""
                    />
                  </div>
                  <div className="col-lg-3 col-sm-4 col-6">
                    <label htmlFor="dailyUnloadingCapacity">
                      Daily Unloading Capacity
                    </label>
                    <input
                      id="dailyUnloadingCapacity"
                      type="text"
                      value={offer?.DailyUnloadingCapacity || "No"}
                      className="form-control"
                      readOnly
                    />
                  </div>
                  <div className="col-lg-3 col-sm-4 col-6">
                    <label htmlFor="unloadingResponsibility">
                      Unloading Responsibility
                    </label>
                    <input
                      id="unloadingResponsibility"
                      type="text"
                      value={offer?.UnloadingResponsibility || "Buyer"}
                      className="form-control"
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-3 col-6">
                <div className="actions">
                  <div className="row">
                    <div className="col-12 mb-2">
                      {btnRequestShippingDetails && (
                        <button className="submit-btn-more">
                          Request Shipping Details
                        </button>
                      )}
                    </div>
                    <div className="col-12 mb-2">
                      {btnLogisticsSupport && (
                        <button className="submit-btn-more">
                          Logistics Support
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === "pricing" && (
          <div className="tab-content active">
            {/* <div className="row">
              <div className="col-lg-9 col-sm-9 col-6"> */}
            <div className="row">
              <div className="col-lg-3 col-sm-4 col-6">
                <label htmlFor="fobSalePrice">
                  FOB Sale Price - Total (INR)
                </label>
                <input
                  id="fobSalePrice"
                  type="text"
                  value={formatData(
                    convertToCurrency(offer?.FOBSalePrice, "INR")
                  )}
                  className="form-control"
                  readOnly
                />
              </div>

              <div className="col-lg-3 col-sm-4 col-6">
                <label htmlFor="fobSalePrice">
                  FOB Sale Price - Total (USD)
                </label>
                <input
                  id="fobSalePrice"
                  type="text"
                  value={formatData(offer?.FOBSalePrice)}
                  className="form-control"
                  readOnly
                />
              </div>
              <div className="col-lg-3 col-sm-4 col-6">
                <label htmlFor="fobSalePrice">FOB Sale Price (INR/MT)</label>
                <input
                  id="fobSalePrice"
                  type="text"
                  value={formatData(
                    convertToCurrency(offer?.FOBSalePrice, "INR") /
                      offer?.Quantity
                  )}
                  className="form-control"
                  readOnly
                />
              </div>

              <div className="col-lg-3 col-sm-4 col-6">
                <label htmlFor="fobSalePrice">FOB Sale Price (USD/MT)</label>
                <input
                  id="fobSalePrice"
                  type="text"
                  value={formatData(offer?.FOBSalePrice / offer?.Quantity)}
                  className="form-control"
                  readOnly
                />
              </div>

              <div className="col-lg-3 col-sm-4 col-6">
                <label htmlFor="cifSalePrice">
                  CIF Sale Price - Total (INR)
                </label>
                <input
                  id="cifSalePrice"
                  type="text"
                  value={formatData(
                    convertToCurrency(offer?.CIFSalePrice, "INR")
                  )}
                  className="form-control"
                  readOnly
                />
              </div>
              <div className="col-lg-3 col-sm-4 col-6">
                <label htmlFor="cifSalePrice">
                  CIF Sale Price - Total (USD)
                </label>
                <input
                  id="cifSalePrice"
                  type="text"
                  value={formatData(offer?.CIFSalePrice)}
                  className="form-control"
                  readOnly
                />
              </div>
              <div className="col-lg-3 col-sm-4 col-6">
                <label htmlFor="cifSalePrice">CIF Sale Price (INR/MT)</label>
                <input
                  id="cifSalePrice"
                  type="text"
                  value={formatData(
                    convertToCurrency(offer?.CIFSalePrice, "INR") /
                      offer?.Quantity
                  )}
                  className="form-control"
                  readOnly
                />
              </div>
              <div className="col-lg-3 col-sm-4 col-6">
                <label htmlFor="cifSalePrice">CIF Sale Price (USD/MT)</label>
                <input
                  id="cifSalePrice"
                  type="text"
                  value={formatData(offer?.CIFSalePrice / offer?.Quantity)}
                  className="form-control"
                  readOnly
                />
              </div>

              <div className="col-lg-3 col-sm-4 col-6">
                <label htmlFor="paymentTerms">Payment Terms</label>
                <input
                  id="paymentTerms"
                  type="text"
                  value={offer?.PaymentTerms || ""}
                  className="form-control"
                  readOnly
                />
              </div>
              <div className="col-lg-3 col-sm-4 col-6">
                <label htmlFor="paymentMethod">Payment Method</label>
                <input
                  id="paymentMethod"
                  type="text"
                  value={offer?.PreferredPaymentMethod || ""}
                  className="form-control"
                  readOnly
                />
              </div>
            </div>
            {/* </div> */}
            {/* <div className="col-lg-3 col-sm-3 col-6">
                <div className="actions">
                  <div className="row">
                    <div className="col-12 mb-2">
                      {btnRequestBestPrice && (
                        <button className="submit-btn-more">
                          Request Best Price
                        </button>
                      )}
                    </div>
                    <div className="col-12 mb-2">
                      {btnNegotiate && (
                        <button className="submit-btn-more">Negotiate</button>
                      )}
                    </div>
                  </div>
                </div>
              </div> */}
            {/*  </div> */}
          </div>
        )}

        {activeTab === "priceBreakup" && (
          <div className="tab-content active">
            <div className="row">
              <div className="col-lg-12">
                <table className="datatable">
                  <tr className="dataheader">
                    <th colSpan="1">Pricing Item</th>
                    <th rowSpan="1">Pricing Component</th>
                    <th rowSpan="1">Amount (Rs)</th>
                    <th rowSpan="1">Amount (USD)</th>
                  </tr>
                  <tr className="primerow">
                    <td>Seller's Quantity (MT)</td>
                    <td className="currency right">{offer?.Quantity}</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr className="altrow">
                    <td>Seller's Price /MT (Rs.)</td>
                    <td className="currency right">
                      {formatData(offer?.Price)}
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr className="primerow">
                    <td>Seller's Total Price</td>
                    <td></td>
                    <td className="currency right">
                      {formatData(offer?.TotalPrice)}
                    </td>
                    <td className="currency right">
                      {formatData(
                        convertToBaseCurrency(offer?.TotalPrice, "INR")
                      )}
                    </td>
                  </tr>
                  <tr className="altrow">
                    <td>AgroPreneur's Charges</td>
                    <td className="currency right">
                      {formatData(offer?.APCommissionPercentage)}%
                    </td>
                    <td className="currency right">
                      {formatData(
                        convertToCurrency(offer?.APCommission, "INR")
                      )}
                    </td>
                    <td className="currency right">
                      {formatData(offer?.APCommission)}
                    </td>
                  </tr>
                  <tr className="primerow">
                    <td>Sorting & Grading Charges</td>
                    <td className="currency right">
                      {formatData(offer?.SortGradeChargedPercentage)}%
                    </td>
                    <td className="currency right">
                      {formatData(
                        convertToCurrency(offer?.SortGradeCharged, "INR")
                      )}
                    </td>
                    <td className="currency right">
                      {formatData(offer?.SortGradeCharged)}
                    </td>
                  </tr>
                  <tr className="altrow">
                    <td>Operations & Finance Charges</td>
                    <td className="currency right">
                      {formatData(offer?.OpsFinChargesPercentage)}%
                    </td>
                    <td className="currency right">
                      {formatData(
                        convertToCurrency(offer?.OpsFinCharges, "INR")
                      )}
                    </td>
                    <td className="currency right">
                      {formatData(offer?.OpsFinCharges)}
                    </td>
                  </tr>
                  <tr className="altrow">
                    <td>Inland Transport Charges</td>
                    <td className="currency right">
                      {offer?.InlandTransport
                        ? formatData(offer?.InlandTransport / offer?.Quantity)
                        : 0}
                    </td>
                    <td className="currency right">
                      {formatData(
                        convertToCurrency(offer?.InlandTransport, "INR")
                      )}
                    </td>
                    <td className="currency right">
                      {formatData(offer?.InlandTransport)}
                    </td>
                  </tr>
                  <tr className="primerow bold-font">
                    <td>Seller's BASE Price</td>
                    <td></td>
                    <td className="currency right">
                      {formatData(convertToCurrency(offer?.BasePrice, "INR"))}
                    </td>
                    <td className="currency right">
                      {formatData(offer?.BasePrice)}
                    </td>
                  </tr>
                  <tr className="altrow">
                    <td>Margin</td>
                    <td className="currency right">
                      {formatData(offer?.MarginPercentage)}%
                    </td>
                    <td className="currency right">
                      {formatData(convertToCurrency(offer?.Margin, "INR"))}
                    </td>
                    <td className="currency right">
                      {formatData(offer?.Margin)}
                    </td>
                  </tr>
                  <tr className="primerow bold-font">
                    <td>FOB Sale Price</td>
                    <td></td>
                    <td className="currency right">
                      {formatData(
                        convertToCurrency(offer?.FOBSalePrice, "INR")
                      )}
                    </td>
                    <td className="currency right">
                      {formatData(offer?.FOBSalePrice)}
                    </td>
                  </tr>
                  <tr className="altrow">
                    <td>Export Duty</td>
                    <td className="currency right">
                      {formatData(offer?.ExportDutyPercentage)}%
                    </td>
                    <td className="currency right">
                      {formatData(convertToCurrency(offer?.ExportDuty, "INR"))}
                    </td>
                    <td className="currency right">
                      {formatData(offer?.ExportDuty)}
                    </td>
                  </tr>
                  <tr className="altrow">
                    <td>Shipping & Insurance</td>
                    <td className="currency right">
                      Rs. {formatData(offer?.ShippingInsurancePercentage)} / MT
                    </td>
                    <td className="currency right">
                      {formatData(
                        convertToCurrency(offer?.ShippingInsurance, "INR")
                      )}
                    </td>
                    <td className="currency right">
                      {formatData(offer?.ShippingInsurance)}
                    </td>
                  </tr>
                  <tr className="altrow">
                    <td>GST (Local Taxes)</td>
                    <td></td>
                    <td className="currency right">
                      {formatData(convertToCurrency(offer?.GST, "INR"))}
                    </td>
                    <td className="currency right">{formatData(offer?.GST)}</td>
                  </tr>
                  <tr className="primerow bold-font">
                    <td>CIF Sale Price</td>
                    <td></td>
                    <td className="currency right">
                      {formatData(
                        convertToCurrency(offer?.CIFSalePrice, "INR"),
                        "INR"
                      )}
                    </td>
                    <td className="currency right">
                      {formatData(offer?.CIFSalePrice)}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        )}

        {activeTab === "others" && (
          <div className="tab-content active">
            <div className="row">
              <div className="col-lg-9 col-sm-9 col-6">
                <div className="row">
                  <div className="col-lg-12 col-sm-12 col-12">
                    <label htmlFor="specialInstructionsBuyer">
                      Special Instructions for Buyer
                    </label>
                    <textarea
                      id="specialInstructionsBuyer"
                      value={offer?.SpecialInstructionsBuyer || ""}
                      className="form-control"
                      readOnly
                      rows="4"
                      placeholder="Special instructions for the buyer..."
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-3 col-6">
                <div className="actions">
                  <div className="row">
                    <div className="col-12 mb-2"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {activeTab === "remarks" && (
          <div className="tab-content active">
            <div className="row">
              <div className="col-lg-9 col-sm-9 col-6">
                <div className="row">
                  <div className="col-lg-12 col-sm-12 col-12">
                    <label htmlFor="specialInstructionsBuyer">Remarks</label>
                    <textarea
                      id="remarks"
                      value={offer?.Remarks || ""}
                      className="form-control"
                      readOnly
                      rows="4"
                      placeholder="Remarks"
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-3 col-6">
                <div className="actions">
                  <div className="row">
                    <div className="col-12 mb-2"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {activeTab === "queries" && (
          <div className="tab-content active">
            <div className="row">
              <div className="col-lg-10 col-sm-9 col-12">
                <table>
                  <thead>
                    <tr>
                      <th>Query Date</th>
                      <th>Query</th>
                      <th>Reply Date</th>
                      <th>Reply</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colSpan="4">No queries available for this offer</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="col-lg-2 col-sm-3 col-12">
                <div className="actions">
                  {btnRaiseQuery && (
                    <button className="submit-btn-more">Raise Query</button>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default OfferDetails;
